(function () {
  function init(gallery) {
    if (gallery.dataset.galleryNavInit) return;
    gallery.dataset.galleryNavInit = 'true';

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var list = viewer && viewer.querySelector('.product__media-list');
    if (!list) return;

    var counterCurrent = gallery.querySelector('[data-gallery-current]');

    function items() {
      return Array.prototype.slice.call(list.querySelectorAll('.product__media-item[data-media-id]'));
    }

    function activeIndex() {
      var all = items();
      for (var i = 0; i < all.length; i++) {
        if (all[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function updateCounter() {
      if (counterCurrent) counterCurrent.textContent = String(activeIndex() + 1);
    }

    function go(dir) {
      var all = items();
      if (all.length < 2) return;
      var target = all[(activeIndex() + dir + all.length) % all.length];
      var mediaId = target.getAttribute('data-media-id');
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
      updateCounter();
    }

    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });

    gallery.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea, select')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });

    new MutationObserver(updateCounter).observe(list, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    updateCounter();
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
